// Ogni modifica alla bozza segna il profilo come "modificato": abilita SALVA PROFILO in Il mio CV
export default {
  addLanguage: ({ commit }, payload) => {
    commit('ADD_LANGUAGE', payload)
    commit('SET_CHANGED', true)
  },
  updateLanguage: ({ commit }, payload) => {
    commit('UPDATE_LANGUAGE', payload)
    commit('SET_CHANGED', true)
  },
  removeLanguage: ({ commit }, index) => {
    commit('REMOVE_LANGUAGE', index)
    commit('SET_CHANGED', true)
  },
  addEducation: ({ commit }, payload) => {
    commit('ADD_EDUCATION', payload)
    commit('SET_CHANGED', true)
  },
  updateEducation: ({ commit }, payload) => {
    commit('UPDATE_EDUCATION', payload)
    commit('SET_CHANGED', true)
  },
  removeEducation: ({ commit }, index) => {
    commit('REMOVE_EDUCATION', index)
    commit('SET_CHANGED', true)
  },
  addExperience: ({ commit }, payload) => {
    commit('ADD_EXPERIENCE', payload)
    commit('SET_CHANGED', true)
  },
  updateExperience: ({ commit }, payload) => {
    commit('UPDATE_EXPERIENCE', payload)
    commit('SET_CHANGED', true)
  },
  removeExperience: ({ commit }, index) => {
    commit('REMOVE_EXPERIENCE', index)
    commit('SET_CHANGED', true)
  },
  addSkill: ({ commit }, payload) => {
    commit('ADD_SKILL', payload)
    commit('SET_CHANGED', true)
  },
  removeSkill: ({ commit }, index) => {
    commit('REMOVE_SKILL', index)
    commit('SET_CHANGED', true)
  },
  addCourse: ({ commit }, payload) => {
    commit('ADD_COURSE', payload)
    commit('SET_CHANGED', true)
  },
  updateCourse: ({ commit }, payload) => {
    commit('UPDATE_COURSE', payload)
    commit('SET_CHANGED', true)
  },
  removeCourse: ({ commit }, index) => {
    commit('REMOVE_COURSE', index)
    commit('SET_CHANGED', true)
  },
  addLicence: ({ commit }, payload) => {
    commit('ADD_LICENCE', payload)
    commit('SET_CHANGED', true)
  },
  removeLicence: ({ commit }, index) => {
    commit('REMOVE_LICENCE', index)
    commit('SET_CHANGED', true)
  },
  setHasCar: ({ commit }, payload) => {
    commit('SET_HAS_CAR', payload)
    commit('SET_CHANGED', true)
  },
  setOther: ({ commit }, payload) => {
    commit('SET_OTHER', payload)
    commit('SET_CHANGED', true)
  },
  // da chiamare dopo il salvataggio sul backend (API #6/#7, non ancora disponibili)
  setChanged: ({ commit }, payload) => {
    commit('SET_CHANGED', payload)
  }
}
